
import { Component, Mixins, Watch } from "vue-property-decorator";
import { IColumnFilter, IFilter } from "@/types";
import TableMixin from "@/mixins/table";
import PageTabs from "@/components/base/PageTabs.vue";
import PageLayout from "@/components_v3/layout/PageLayout.vue";
import { Advertiser } from "@/services/advertiser/Advertiser";
import AdvertiserSingle from "@/components/revenue/advertiser/AdvertiserSingle.vue";
import { getAllInvoices, getAllStatTasks, getOneAdvertiserCompiled, getAdvertisersAccesses, updateAdvertiserAccesses } from "@/api/revenue";
import { downloadExcelFile, showServerError } from "@/utils";
import { eventBus } from "@/eventbus";
import OffersTable from "@/components/offers/offer/OffersTable.vue";
import { getEmployeesOffersV2 } from "@/api/offers";
import { OffersColumns, OffersFilters } from "@/services/TablePage/offers";
import { Offer } from "@/services/offers/Offer";
import TablePageFilters from "@/components/base/filters/TablePageFilters.vue";
import SvgFileDownloaded from "@/assets/icons/file-downloaded.svg";
import Search from "@/components/base/Search.vue";
import debounce from "lodash-es/debounce";
import OfferPeriodSelect from "@/components/offers/offer/OfferPeriodSelect.vue";
import { namespace } from "vuex-class";
import OfferStatistic from "@/components/offers/offer/OfferStatistic.vue";
import { InvoicesAdvertisersColumns, InvoicesAdvertisersFilters } from "@/services/TablePage/invoicesAdvertisers";
import InvoicesTable from "@/components/revenue/invoice/InvoicesTable.vue";
import { AccessesAdvertisersFilters } from "@/services/TablePage/accessesAdvertisers";
import TasksTable from "@/components/revenue/statTask/TasksTable.vue";
import AccessesAdvertiserTable from "@/components/revenue/advertiser/AccessesAdvertiserTable.vue";
import { StatTasksColumns, StatTasksFilters } from "@/services/TablePage/statTasks";
import Contracts from "@/components/revenue/advertiser/Contracts.vue";
import CreateBtn from "@/components/base/buttons/CreateBtn.vue";
import Status from "@/components/base/Status.vue";
import SvgMagicWand from "@/assets/icons/magic-wand.svg";
import BaseButton from "@/components-UI/BaseButton.vue";
import { translateAdvertiserStatus } from "@/utils/translate";
import FormModal from "@/components/base/FormModal.vue";
import AccessAdvertiserForm from "@/components/revenue/advertiser/AccessAdvertiserForm.vue";
import SvgPlus from "@/assets/icons/plus.svg";
import { NotificationMessage } from "@/utils/notification";

const revenue = namespace('revenueModule');
const invoice = namespace('invoiceModule');

interface ITabItem {
    tab: string,
    component?: any,
    additionalComponent?: any,
    additionalTitleAction?: any,
    apiMethod?: Function,
    itemClass?: any,
    columns?: IColumnFilter[],
    filters?: IFilter[] | AccessesAdvertisersFilters,
    isGroupFilters?: boolean,
    errorText?: string,
    isDownload?: boolean,
    isCreateBtns?: boolean,
    downloadMethod?: Function,
    isCreate?: boolean,
    createMethod?: any,
    isSearch?: boolean,
    isNeedDownloadParams?: boolean,
    class?: string,
    key?: string,
}

@Component({
    beforeRouteLeave(to: any, from: any, next: (arg0?: (vm: any) => void) => void) {
        this.setAdvertiser(null);
        next();
    },
    beforeRouteEnter(to: any, from: any, next: (arg0?: (vm: any) => void) => void) {
        next(vm => {
            if (from.fullPath !== '/') {
                vm.beforeListRoute = from.fullPath;
            }
        });
    },
    components: {
        BaseButton,
        SvgMagicWand,
        Status,
        CreateBtn,
        Contracts,
        Search,
        SvgFileDownloaded,
        TablePageFilters,
        AdvertiserSingle,
        PageTabs,
        PageLayout,
        FormModal,
        AccessAdvertiserForm,
        SvgPlus,
    },
    methods: {
        translateAdvertiserStatus,
    },
})

export default class AdvertiserSingleWrap extends Mixins(TableMixin) {
    @revenue.Mutation('SET_CURRENT_ADVERTISER') setAdvertiser!: (payload: any) => void;
    @revenue.Mutation('SET_ADVERTISER_FIELDS') setAdvertiserFields;
    @invoice.Mutation('SET_ADVERTISER') setAdvertiserInvoice;
    @revenue.Mutation('SET_ACCOUNT_MANAGER_NAME') setAccountManagerName;

    beforeListRoute = '/revenue/advertisers';
    // данные рекламодателя
    advertiserStore;
    // имя аккаунт-менеджера
    accountManagerNameStore: string | null | undefined = '';
    advertiser = {} as Advertiser;
    settings = { loading: false };
    tab: number = 0;
    currentFilters = [] as IFilter[] | AccessesAdvertisersFilters;
    currentColumns = [] as IColumnFilter[];
    currentOffset = 0;
    isTableWithSections: boolean = false;
    isDownloadLoading: boolean = false;
    tabItems: ITabItem[] = [];
    isAccessModalOpen: boolean = false;

    get getTabs(): ITabItem[] {
        return [
            {
                tab: 'Основное',
                isCreateBtns: true,
            },
            {
                tab: 'Офферы',
                component: OffersTable,
                additionalComponent: OfferStatistic,
                apiMethod: getEmployeesOffersV2,
                additionalTitleAction: OfferPeriodSelect,
                isDownload: true,
                downloadMethod: getEmployeesOffersV2,
                isSearch: true,
                itemClass: Offer,
                columns: new OffersColumns().getColumnsForAdvertiserDetailPage,
                filters: new OffersFilters().filters,
                isGroupFilters: true,
                errorText: 'Ошибка загрузки списка офферов',
                class: 'offers',
            },
            {
                tab: 'Договоры',
            },
            {
                tab: 'Счета',
                component: InvoicesTable,
                apiMethod: getAllInvoices,
                isCreate: true,
                createMethod: this.redirectToCreateInvoice,
                columns: new InvoicesAdvertisersColumns().getColumnsForAdvertiserDetailPage,
                filters: new InvoicesAdvertisersFilters().filters,
                errorText: 'Ошибка загрузки списка счетов',
            },
            {
                tab: 'Загрузки',
                component: TasksTable,
                apiMethod: getAllStatTasks,
                isCreate: true,
                createMethod: this.redirectToCreateTask,
                columns: new StatTasksColumns().getColumnsForAdvertiserDetailPage,
                filters: new StatTasksFilters().filters,
                errorText: 'Ошибка загрузки списка загрузок',
            },
            {
                tab: 'Блокировки',
                component: AccessesAdvertiserTable,
                apiMethod: getAdvertisersAccesses,
                isCreate: true,
                createMethod: this.createAccesseAdvertiser,
                filters: new AccessesAdvertisersFilters(),
                errorText: 'Ошибка загрузки списка партнёров',
                key: 'accesses_advertiser',
            },
        ];
    }

    get getTitle(): string {
        return this.tab === 0 ? this.advertiser.name : `${this.advertiser.name} (${this.advertiser.id})`;
    }

    get isShowTableFilters(): boolean {
        const currentTab = this.tabItems[this.tab];
        if (!currentTab) return false;
        const f = currentTab.filters;
        return this.tab > 0 && (Array.isArray(f) ? f.length > 0 : (f?.filters?.length ?? 0) > 0);
    }

    backToList(): void {
        this.$router.push({ path: this.beforeListRoute });
    }

    changeTab(tab: number): void {
        this.tab = tab;
        this.setDefaultParamsObject({});
        this.setFiltersParamsObject({});
        const isAccessesTab = tab === 5;
        if (isAccessesTab) {
            const q = this.$route.query;
            const status = q.affiliate_status;
            const hasStatus = status != null && (Array.isArray(status) ? status.length > 0 : true);
            const params: any = { tab };
            if (!hasStatus) {
                params.affiliate_status = ['active'];
            } else {
                params.affiliate_status = Array.isArray(status) ? status : [status];
            }
            this.setFiltersParamsObject(params);
            this.updateQueryString(params);
        } else {
            this.updateQueryString({});
        }
        this.updateTable();
        const tabItem = this.tabItems[tab];
        const filtersArray = tabItem?.filters && !Array.isArray(tabItem.filters)
            ? (tabItem.filters as any).filters
            : (tabItem?.filters ?? []);
        this.clearSelectFilters(filtersArray);
    }

    async updateTable(): Promise<void> {
        if ([0, 2].includes(this.tab)) return;
        this.dataTable = [];
        const tab = this.tabItems[this.tab];
        this.currentFilters = tab.filters!;
        this.currentColumns = tab.columns!;
        this.itemsClass = tab.itemClass!;
        this.apiMethod = tab.apiMethod;
        await this.getPagination();
        this.isTableSectionsAvailability();
    }

    async onSaveAccesses(affiliatesIds: number[]): Promise<void> {
        try{
            await updateAdvertiserAccesses({
                id: this.advertiser.id,
                affiliates_ids: affiliatesIds,
                is_block: true,
            });
            new NotificationMessage(`Изменения сохранены`, 'success');
            await this.updateTable();
        }catch(err){
            showServerError(err, 'Не получилось добавить партнера');
        }finally{
            this.isAccessModalOpen = false;
        }
    }

    @Watch('$route.query')

    setTabToUrl(query?: object): void {
        if (Number(this.$route.query.tab!) === this.tab) return;

        const params = { ...query, ...{ tab: this.tab } };
        this.updateQueryString(params);
    }

    clearFilters(): void {
        this.clearFilter();
    }

    async getPagination(offset?: number): Promise<void> {
        this.currentOffset = offset || 0;
        try {
            await this.getTableData(offset);
        } catch (err) {
            showServerError(err, this.tabItems[this.tab].errorText!);
        }
    }

    async created(): Promise<void> {
        await this.getAdvertiser();
        this.tab = Number(this.$route.query.tab!) || 0;
        this.setTabToUrl();
        this.tabItems = this.getTabs;
        await this.updateTable();
        eventBus.$on('update-advertiser', this.getAdvertiser);
    }

    async getAdvertiser(): Promise<void> {
        const ID = Number(this.$route.params.id);
        try {
            const data = await getOneAdvertiserCompiled(ID);
            this.advertiser = new Advertiser(data);
            this.setAdvertiser({ id: this.advertiser.id, name: this.advertiser.name });
            document.title = `${this.advertiser.name}`;
        } catch (err) {
            showServerError(err, 'Рекламодатель не найден');
        }
    }

    async download(): Promise<void> {
        this.isDownloadLoading = true;
        try {
            const tab = this.tabItems[this.tab];

            if (!!tab.downloadMethod) {
                const params = this.getFiltersParamsObject;
                const columns = this.$route.query.columns as string[];
                const fields = columns.filter(i => !i.includes('goals'));
                fields.push('goals');
                params.fields = fields.join(',');
                const headers = { "Accept": "application/vnd.ms-excel" };
                const responseType = 'blob';
                const file = await tab.downloadMethod(params, headers, responseType);
                const name = tab.tab;
                downloadExcelFile(file, name, 'xlsx');
            }
        } catch (err) {
            showServerError(err, 'Файл не загружен');
        }
        this.isDownloadLoading = false;
    }

    searchDebounce = debounce((search: string): void => {
        this.search = search;
        this.setCustomQuery({ search });
        this.getPagination(0);
    }, 500);

    setCustomQuery(customQuery: any): void {
        const query = this.getFiltersParamsObject;
        const offset = this.$route.query.offset;
        const allQuery = { ...query, ...customQuery, offset };
        this.setFiltersParamsObject(allQuery);
        this.updateQueryString(allQuery);
    }

    isTableSectionsAvailability(): void {
        const el = this.$el;
        this.isTableWithSections = !!el.querySelector('.extended-report-table__custom-header');
    }

    beforeDestroy(): void {
        this.setAdvertiser(null);
        eventBus.$off('update-advertiser', this.getAdvertiser);
    }

    redirectToCreateInvoice(): void {
        this.setDataToStore();
        this.$router.push({ name: 'invoice-creation' });
    }

    redirectToCreateTask(): void {
        this.setDataToStore();
        this.$router.push({ name: 'stat-task-creation' });
    }

    createAccesseAdvertiser(): void {
        this.isAccessModalOpen = true;
    }

    private setDataToStore(): void {
        // данные для создания счета и загрузки
        this.advertiserStore = {
            id: this.advertiser.id,
            name: this.advertiser.name,
        };
        const advertiserInvoiceStore = {
            id: this.advertiser.id,
            name: this.advertiser.name,
            contractors: this.advertiser.contractors,
            status: this.advertiser.status,
            tag: this.advertiser.tag,
            account_manager: this.advertiser.account_manager,
            managers: this.advertiser.managers,
            projects: this.advertiser.projects,
            currency: this.advertiser.currency,
        };
        this.accountManagerNameStore = this.advertiser.account_manager
            ? this.advertiser.account_manager!.full_name : null;
        // передаем ву store данные рекламодателя и менеджера,
        // эти данные используем после перехода на другую страницу
        // в частности на странице создания счета, и странице создания задачи
        // на загрузку статистики
        this.setAdvertiserFields(this.advertiserStore);
        this.setAdvertiserInvoice(advertiserInvoiceStore);
        this.setAccountManagerName(this.accountManagerNameStore);
    }

}

